module.exports = __webpack_public_path__ + "assets/img/丰富的产品体系.b4d7e23b.jpg";